// Redux Module Available
import navControlReducer from "../../nav-control/redux/reducers/index";
import partymodeReducer from "../../partymode/redux/reducers/index";
import automixReducer from "../../automix/redux/reducers/index";
import shortcutReducer from "../../shortcut/redux/reducers/index";
import cartReducer from "../../cart/redux/reducers/index";

const customReducers = [
  navControlReducer,
  automixReducer,
  partymodeReducer,
  shortcutReducer,
  cartReducer
];

export default customReducers;
